import { prepHandleEvent } from "./prepHandleEvent";
import { enumKeySource } from "../constants";

export function handleKeyPress(event) {
  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;

  var handled = myApp.HandleKeyboard(event, enumKeySource.keyPress);
  event.preventDefault(); // Prevent tab key from being handled by browser
}
